import { Controller } from "@hotwired/stimulus"
import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "toast"
  
  static values = {
    message: String,
    type: String
  }

  connect() {
    super.connect()
    this.show()
  }

  show() {
    const data = {
      title: this.messageValue,
      message: "",
      type: this.typeValue || "success"
    }

    this.send("show", data, () => {
      // Optional callback
    })
  }
}
